import './Information.css';



function Information() {

  return (

    <div className="wrapper">
    
      <div className="column">

        <h2>Our Project</h2>
        <div>
          <p> We aim to develop an innovative 3D data visualization application that allows users to navigate and view key data about the streets of the 13th district of Paris, such as the revenue and net profit of selected businesses.</p>
          <br></br>
          <p> This application offers several benefits to users, including helping investors and entrepreneurs make more informed decisions, enabling local authorities to implement targeted actions to support local businesses, and providing individuals with insights into high-potential areas to live and settle in.</p>
          <br></br>
          <p> Overall, our project provides a new perspective on the economic activity of Paris and enables different actors to better understand key data to make more informed decisions.</p>
        </div>
        <h2>Who am I?</h2>
        <div>
          <p> I am a former chartered accountant with 10 years of experience working for leading French firms and corporations. My background in accounting, finance, and taxation has given me a deep understanding of business operations and financial management.</p>
          <br></br>
          <p> Recently, I set myself a new challenge by becoming a full-stack developer with a passion for cutting-edge technologies. I specialize in JavaScript and I am proficient in React, a popular library for building web interfaces. I'm also skilled in Three.js, a JavaScript library used to create 3D graphics and animations in the browser.</p>
          <br></br>
          <p>My unique combination of expertise in accounting and computer skills enables me to offer a wide range of services to my clients. Whether you need help with financial analysis, tax planning, or software development, I have the skills and experience to deliver top-notch results.</p>
        </div>
      </div>
      <div className="column">
        <h2>How does it work?</h2>
        <div>
          The data is sourced from the Ministry of Finance and Economy, along with SIRENE. These reliable and up-to-date datasets provide valuable insights. We ensure that the data is meticulously updated on a daily basis, ensuring its accuracy and relevance.
        </div>
        <h2>How to test the application?</h2>
        <div>
          By creating an account on our website, you can effortlessly access our services, which include the interactive map, and take full advantage of our extensive database.
        </div>
        <h2>Recommendation</h2>
        <div>
          To enhance your user experience, we highly recommend using a computer with a minimum configuration of 16GB of RAM and an M1 processor(or equivalent), along with the Google Chrome browser.
        </div>
        <h2>Contact</h2>
        <div>
          Please feel free to explore my website and learn more about my services. If you have any questions or would like to discuss your project, do not hesitate to contact me using the email address below: anthony2.pho@gmail.com . I will do my best to respond to your inquiry as soon as possible. Thank you for your interest in my services!
        </div>


        <div>
          <img src="/icons/icon-navbar.png" className="information-icon" ></img>
        </div>
      </div>
    </div>

  );
}

export default Information;